import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { validateStep6 } from './validations';

import { Field } from 'redux-form';
import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';
import DropDownSelect from '../DropDownSelect';

import {
    Container,
    ButtonGroupWrapper,
    MultipleGroupWrapper,
    MultipleGroupLast
} from '../../containers/DefaultStyles/FormDetails';

const MultipleGroupWrapperFullRowMobile = styled(MultipleGroupWrapper)`
    @media (max-width: 30em) {
        flex-wrap: wrap;

        .fullRowMobile {
            width: calc(100% - 1em);
            flex: none;
            margin-top: 0.75em;
        }
    }
`;

class VoteRegistrationStep6Form extends React.Component {
    constructor(props) {
        super(props);
        this.state = { class: 'default' };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange() {
        this.setState({ class: 'changed' });
    }

    render() {
        return (
            <Container autocomplete="on" onSubmit={this.props.handleSubmit}>
                <MultipleGroupWrapperFullRowMobile>
                    <Field
                        name="prevPrefix"
                        component={DropDownSelect}
                        options={this.props.prefix}
                        defaultOption={'Choose'}
                        label="Prev Prefix"
                        type="text"
                        onChange={this.handleChange}
                        class={this.state.class}
                    />
                    <Field
                        name="prevFirstName"
                        component={InputGroup}
                        type="text"
                        label="Prev First name"
                        placeholder="First Name"
                        autocomplete="off"
                    />
                    <Field
                        name="prevMiddleName"
                        component={InputGroup}
                        type="text"
                        label="Prev Middle name"
                        placeholder="Middle Name"
                        autocomplete="off"
                        class="fullRowMobile"
                    />
                </MultipleGroupWrapperFullRowMobile>
                <MultipleGroupLast>
                    <Field
                        name="prevLastName"
                        component={InputGroup}
                        type="text"
                        label="Prev Last name"
                        placeholder="Last Name"
                        autocomplete="off"
                    />
                    <Field
                        name="prevSuffix"
                        component={DropDownSelect}
                        options={this.props.suffix}
                        defaultOption={'Choose'}
                        label="Prev Suffix"
                        type="text"
                        onChange={this.handleChange}
                        class={this.state.class}
                    />
                </MultipleGroupLast>
                <ButtonGroupWrapper>
                    <TwoGroup>
                        <Button label="Back" onClick={this.props.onBack} />
                        <Button
                            primary={true}
                            type="submit"
                            label="Continue"
                            disabled={this.props.invalid}
                        />
                    </TwoGroup>
                </ButtonGroupWrapper>
            </Container>
        );
    }
}

VoteRegistrationStep6Form.propTypes = {
    onBack: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func,
    prefix: PropTypes.array,
    suffix: PropTypes.array
};

export default compose(
    connect(() => ({
        initialValues: {}
    })),
    reduxForm({
        form: 'voteRegistrationStep6Form',
        validate: validateStep6,
        destroyOnUnmount: false
    })
)(VoteRegistrationStep6Form);
